<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="TOC"><a id="page_6"></a><a id="page_7"></a>Table of Contents</h1>
<p class="toc1"><a href="#/OEBPS/005prologue">PROLOGUE</a></p>
<p class="toc"><a href="#/OEBPS/006part1">PART ONE: <em>Lovers &amp; Strangers</em></a></p>
<p class="toc1"><a href="#/OEBPS/007chapter1part1">Chapter 1</a></p>
<p class="toc1"><a href="#/OEBPS/008chapter2part1">Chapter 2</a></p>
<p class="toc1"><a href="#/OEBPS/009chapter3part1">Chapter 3</a></p>
<p class="toc1"><a href="#/OEBPS/010chapter4part1">Chapter 4</a></p>
<p class="toc1"><a href="#/OEBPS/011chapter5part1">Chapter 5</a></p>
<p class="toc1"><a href="#/OEBPS/012chapter6part1">Chapter 6</a></p>
<p class="toc1"><a href="#/OEBPS/013chapter7part1">Chapter 7</a></p>
<p class="toc1"><a href="#/OEBPS/014chapter8part1">Chapter 8</a></p>
<p class="toc1"><a href="#/OEBPS/015chapter9part1">Chapter 9</a></p>
<p class="toc1"><a href="#/OEBPS/016chapter10part1">Chapter 10</a></p>
<p class="toc1"><a href="#/OEBPS/017chapter11part1">Chapter 11</a></p>
<p class="toc1"><a href="#/OEBPS/018chapter12part1">Chapter 12</a></p>
<p class="toc1"><a href="#/OEBPS/019chapter13part1">Chapter 13</a></p>
<p class="toc1"><a href="#/OEBPS/020chapter14part1">Chapter 14</a></p>
<p class="toc1"><a href="#/OEBPS/021chapter15part1">Chapter 15</a></p>
<p class="toc1"><a href="#/OEBPS/022chapter16part1">Chapter 16</a></p>
<p class="toc1"><a href="#/OEBPS/023chapter17part1">Chapter 17</a></p>
<p class="toc1"><a href="#/OEBPS/024chapter18part1">Chapter 18</a></p>
<p class="toc1"><a href="#/OEBPS/025chapter19part1">Chapter 19</a></p>
<p class="toc1"><a href="#/OEBPS/026chapter20part1">Chapter 20</a></p>
<p class="toc1"><a href="#/OEBPS/027chapter21part1">Chapter 21</a></p>
<p class="toc1"><a href="#/OEBPS/028chapter22part1">Chapter 22</a></p>
<p class="toc1"><a href="#/OEBPS/029chapter23part1">Chapter 23</a></p>
<p class="toc"><a href="#/OEBPS/030part2">PART TWO: <em>Saints &amp; Sinners</em></a></p>
<p class="toc1"><a href="#/OEBPS/031chapter24part2">Chapter 24</a></p>
<p class="toc1"><a href="#/OEBPS/032chapter25part2">Chapter 25</a></p>
<p class="toc1"><a href="#/OEBPS/033chapter26part2">Chapter 26</a></p>
<p class="toc1"><a href="#/OEBPS/034chapter27part2">Chapter 27</a></p>
<p class="toc1"><a href="#/OEBPS/035chapter28part2">Chapter 28</a></p>
<p class="toc1"><a href="#/OEBPS/036chapter29part2">Chapter 29</a></p>
<p class="toc1"><a href="#/OEBPS/037chapter30part2">Chapter 30</a></p>
<p class="toc1"><a href="#/OEBPS/038chapter31part2">Chapter 31</a></p>
<p class="toc1"><a href="#/OEBPS/039chapter32part2">Chapter 32</a></p>
<p class="toc"><a href="#/OEBPS/040part3">PART THREE: <em>Winners &amp; Losers</em></a></p>
<p class="toc1"><a href="#/OEBPS/041chapter33part3">Chapter 33</a></p>
<p class="toc1"><a href="#/OEBPS/042chapter34part3">Chapter 34</a></p>
<p class="toc1"><a href="#/OEBPS/043chapter35part3">Chapter 35</a></p>
<p class="toc1"><a href="#/OEBPS/044chapter36part3">Chapter 36</a></p>
<p class="toc1"><a href="#/OEBPS/045chapter37part3">Chapter 37</a></p>
<p class="toc1"><a href="#/OEBPS/046chapter38part3">Chapter 38</a></p>
<p class="toc1"><a href="#/OEBPS/047chapter39part3">Chapter 39</a></p>
<p class="toc1"><a href="#/OEBPS/048chapter40part3">Chapter 40</a></p>
<p class="toc1"><a href="#/OEBPS/049chapter41part3">Chapter 41</a></p>
<p class="toc1"><a href="#/OEBPS/050chapter42part3">Chapter 42</a></p>
<p class="toc1"><a href="#/OEBPS/051chapter43part3">Chapter 43</a></p>
<p class="toc1"><a href="#/OEBPS/052chapter44part3">Chapter 44</a></p>
<p class="toc1"><a href="#/OEBPS/053epilogue">EPILOGUE</a></p>
<p class="toc1"><a href="#/OEBPS/054substance">An Excerpt from A Woman of Substance</a></p>
<p class="toc1"><a href="#/OEBPS/055otherbooksby">Other Barbara Taylor Bradford titles from RosettaBooks</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004-toc.vue?da8a192a